module.exports = __webpack_public_path__ + "img/icon_e43.2c0e4edd.png";